module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Semibold.e753d43.ttf";